export default "__VITE_ASSET___$9YfvXt__"